<template>
  <sidebar>
    <div class="col-md-12 pt-5 pb-5 pr-2 pl-2">
      <div class="col-md-12 d-flex flex-column align-items-start justify-content-center">
        <div class="col-md-12">
          <h3 class="pb-2">Sobre o animal:</h3>
          <v-autocomplete
            outlined
            placeholder="Selecione o animal"
            item-value="id"
            item-text="name"
            :items="computedHeadquarters"
            style="width:70%"
            return-object
            v-model="animal_kill.matrix"
            @update:search-input="searchAnimal"
            @change="checkAnimal"
            v-if="!isEdition"
            no-data-text="Nenhum resultado..."
            clearable
          ></v-autocomplete>

          <v-text-field
            v-else
            outlined
            placeholder="Selecione o animal"
            style="width:70%"
            v-model="matrix_name"
            :disabled="true"
            no-data-text="Nenhum resultado..."
          ></v-text-field>
        </div>
      </div> 

      <div class="col-md-12 d-flex justify-content-between" v-if="animal_kill.matrix">
        <div class="col-md-5 d-flex align-items-center">
          <h4 class="m-0">Registro: {{animal_kill.matrix.code ? animal_kill.matrix.code : ""}}</h4>
        </div>

        <div class="col-md-5 d-flex align-items-center">
          <h4 class="m-0">Grau de Sangue  {{animal_kill.matrix.degree_blood ? animal_kill.matrix.degree_blood : ""}}:</h4>
        </div>
      </div>

      <v-divider class="mb-7"></v-divider>
      
      <div class="col-md-12 d-flex flex-column">
        <v-autocomplete
          class="mb-7"
          label="Motivo da Baixa"
          :items="computedMotivations"
          item-text="name"
          item-value="id"
          outlined
          return-object
          v-model="animal_kill.kind"
        ></v-autocomplete>
        
        <p 
          v-if="animal_kill.kind"
          class="text-center"
        >{{animal_kill.kind.name}}</p>

        <date-picker
          label="Data da Ocorrência"
          :binding.sync="animal_kill.event_at"
          :readOnly="false"
          :errorsMessages="!checkValidDate ? 'Data não pode ser menor que o nascimento do animal' : ''"
        ></date-picker>
      </div>

      <div class="col-md-12 d-flex justify-content-center" style="margin-top:10%">
        <v-btn 
          class="success" 
          @click="showConfirmation = true"
          :disabled="(!animal_kill.matrix || !animal_kill.kind || !checkValidDate) ? true : false"
        >{{isEdition ? "Editar Baixa" : "Registrar Baixa"}}</v-btn>
        <v-btn outlined class="btn-back ml-5" @click="SET_ACTIVE(false);">Voltar</v-btn>
      </div>

      <modal-confirmation 
        :confirm="showConfirmation"
        title="Confirmação"
        text="Tem certeza que deseja registrar esta baixa ?"
        @close="showConfirmation = false"
        @save="saveKill"
      />

      <modal-alert 
        :active="alertModal"
        :openBirth="openBirth"
        @close="alertModal = false"
      />
    </div>
  </sidebar>
</template>

<script>
import Sidebar from "@/components/layout/Sidebar.vue";
import DatePicker from "@/components/layout/DatePicker";
import {mapActions, mapState, mapMutations} from "vuex";
import helpers from "@/mixins/helpers.js";

export default {
  name:"SidebarKills",
  mixins:[helpers],
  props:{
    service:Object,
    edit:Object,
    farm:String
  },
  components: {
    Sidebar,
    DatePicker,
    ModalConfirmation: () => import("@/components/layout/ModalConfirmation"),
    ModalAlert: () => import("./ModalAlert.vue")
  },
  data() {
    return {
      showConfirmation:false,
      animal_kill:{
        event_at:""
      },
      matrix_name:null,
      animals:[],
      alertModal:false,
      openBirth:{},
      isEdition:false
    }
  },
  computed: {
    ...mapState("animals", ["headquarters", "down_reasons"]),
    ...mapState("sidebar", ["active"]),
    computedMotivations() {
      return this.down_reasons;
    },
    checkValidDate() {
      const matrix = this.animal_kill.matrix;
      if(!matrix || !matrix.born_at || !this.animal_kill.event_at) return true;
      return new Date(this.animal_kill.event_at).getTime() >= new Date(this.parseDate(matrix.born_at)).getTime();
    },
    computedHeadquarters() {
      return this.animals.map(e => ({...e, name:e.code + " - " + e.name + " Registro: " + e.register}));
    }
  },
  methods: {
    ...mapActions("animals", [
      "actionGetAnimalsReasons",
      "actionSearchAnimalsGeneral",
      "actionSaveKill",
      "actionGetAnimalsKills"
    ]),
    ...mapMutations("sidebar", ["SET_ACTIVE"]),
    async getFarms(value) {
      await this.actionGetFarms(value);
    },
    async getHeadquarters(value) {
      await this.actionGetAnimalsHeadquarters(value);
    },
    async saveKill() {
      try {
        await this.actionSaveKill({animal_id:this.animal_kill.matrix.id, event_at:this.animal_kill.event_at, kind:this.animal_kill.kind.id.toString()});
        await this.actionGetAnimalsKills();
      } catch(error) {
        this.$toast.error(`${error}`)
      }
      this.showConfirmation = false;
      this.SET_ACTIVE(false);
      delete this.$route.params.service;
    },
    //Esse metodo busca animais em todas as tabelas do banco vinculada a este usuário
    async searchAnimal(data) {
      if(!this.animal_kill.matrix && data && data.length > 2) {
       this.animals = await this.actionSearchAnimalsGeneral({register:data, farm:this.farm});
      } else {
        this.aniamls = [];
      }
    },
    checkAnimal(data) {
      if(data && data.current_birthday_id) {
        this.openBirth = data;
        this.alertModal = true;
      }
    }
  },
  watch: {
   async edit(newValue) {
      if(newValue.id) {
        await this.searchAnimal(newValue.name);
        this.animal_kill.matrix = this.computedHeadquarters[0];
        this.isEdition = true;
        this.animal_kill.id = newValue.id;
        this.matrix_name = newValue.name;
        this.animal_kill.kind = {id:parseFloat(newValue.down_reason)};
        this.animal_kill.event_at = this.parseDate(newValue.down_reason_at);
      }
      else {
        this.animal_kill = {
          event_at:""
        };
      }
    },
    active(val) {
      if(!val) this.isEdition = false;
    }
  },
  async mounted() {
    await this.actionGetAnimalsReasons();
  }
}
</script>

<style scoped>
  h3 {
    font-size: 1.2rem;
  }

  h4 {
    font-size: 1rem;
  }
  .border-botton {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
</style>